/*
Copyright (c) 2021
*/

import constants from '../../constants';

const {
  REQUEST_ANALYSIS_DATA,
  REQUEST_SCREENER_ANALYSIS_DATA,
  ANALYSIS_DATA_RECEIVED,
  ANALYSIS_SCREENER_DATA_RECEIVED,
  REQUEST_ANALYSIS_CSV,
  REQUEST_ANALYSIS_CSV_WITH_CODE,
  ANALYSIS_CSV_RECEIVED,
  ANALYSIS_CSV_RECEIVED_WITH_CODE,
  REQUEST_WORD_ANSWER,
  WORD_ANSWER_RECEIVED,
  REQUEST_FILTER_DATA,
  FILTER_DATA_RECEIVED,
  ADD_TO_REPORT,
  FETCH_REPORT,
  UPDATE_REPORT,
  REQUEST_ADD_COHORT,
  ADD_COHORT_RESPONSE,
  REQUEST_STICH_VIDEO,
  STICH_VIDEO_RESPONSE,
  REQUEST_ANALYSIS_CLIPS_DATA,
  REQUEST_ANALYSIS_CLIPS_WITHOUT_URL,
  REQUEST_DELETE_CUSTOMTAG,
  DELETE_CUSTOMTAG_RECEIVED,
  REQUEST_DELETE_COHORT,
  DELETE_COHORT_RECEIVED,
  CLEAR_DELETE_CUSTOMTAG,
  CLEAR_DELETE_COHORT,
  REQUEST_CUSTOM_TAG_UPDATE,
  CUSTOM_TAG_UPDATE_RECEIVED,
  CLEAR_CUSTOM_TAG_UPDATE,
  ANALYSIS_CLIPS_DATA_RECEIVED,
  ANALYSIS_CLIPS_WITHOUT_URL_RECEIVED
} = constants.analysisConstants;

export default {
  REQUEST_ANALYSIS_DATA,
  REQUEST_SCREENER_ANALYSIS_DATA,
  ANALYSIS_DATA_RECEIVED,
  ANALYSIS_SCREENER_DATA_RECEIVED,
  REQUEST_ANALYSIS_CSV,
  REQUEST_ANALYSIS_CSV_WITH_CODE,
  ANALYSIS_CSV_RECEIVED,
  ANALYSIS_CSV_RECEIVED_WITH_CODE,
  REQUEST_WORD_ANSWER,
  WORD_ANSWER_RECEIVED,
  REQUEST_FILTER_DATA,
  FILTER_DATA_RECEIVED,
  ADD_TO_REPORT,
  FETCH_REPORT,
  UPDATE_REPORT,
  REQUEST_ADD_COHORT,
  ADD_COHORT_RESPONSE,
  REQUEST_STICH_VIDEO,
  REQUEST_DELETE_CUSTOMTAG,
  DELETE_CUSTOMTAG_RECEIVED,
  REQUEST_DELETE_COHORT,
  DELETE_COHORT_RECEIVED,
  CLEAR_DELETE_CUSTOMTAG,
  CLEAR_DELETE_COHORT,
  REQUEST_CUSTOM_TAG_UPDATE,
  CUSTOM_TAG_UPDATE_RECEIVED,
  CLEAR_CUSTOM_TAG_UPDATE,
  STICH_VIDEO_RESPONSE,
  REQUEST_ANALYSIS_CLIPS_DATA,
  REQUEST_ANALYSIS_CLIPS_WITHOUT_URL,
  ANALYSIS_CLIPS_DATA_RECEIVED,
  ANALYSIS_CLIPS_WITHOUT_URL_RECEIVED,

  requestAnalysisData: payload => ({
    type: REQUEST_ANALYSIS_DATA,
    payload
  }),
  requestScreenerAnalysisData: payload => ({
    type: REQUEST_SCREENER_ANALYSIS_DATA,
    payload
  }),
  analysisDataReceived: () => ({
    type: ANALYSIS_DATA_RECEIVED
  }),
  analysisScreenerDataReceived: () => ({
    type: ANALYSIS_SCREENER_DATA_RECEIVED
  }),
  requestAnalysisCsv: payload => ({
    type: REQUEST_ANALYSIS_CSV,
    payload
  }),
  requestAnalysisCsvWithCode: payload => ({
    type: REQUEST_ANALYSIS_CSV_WITH_CODE,
    payload
  }),
  analysisCsvReceived: () => ({
    type: ANALYSIS_CSV_RECEIVED
  }),
  analysisCsvReceivedWithCode: () => ({
    type: ANALYSIS_CSV_RECEIVED_WITH_CODE
  }),
  requestGraphAnwser: payload => ({
    type: REQUEST_WORD_ANSWER,
    payload
  }),
  wordAnswerReceived: () => ({
    type: WORD_ANSWER_RECEIVED
  }),
  requestFilterData: payload => ({
    type: REQUEST_FILTER_DATA,
    payload
  }),
  filterDataReceived: () => ({
    type: FILTER_DATA_RECEIVED
  }),
  addItemToReport: () => ({
    type: ADD_TO_REPORT
  }),
  updateReportData: () => ({
    type: UPDATE_REPORT
  }),
  addCohort: () => ({
    type: REQUEST_ADD_COHORT
  }),
  cohortResponse: () => ({
    type: ADD_COHORT_RESPONSE
  }),
  stitchVideo: () => ({
    type: REQUEST_STICH_VIDEO
  }),
  stichResponse: () => ({
    type: STICH_VIDEO_RESPONSE
  }),
  requestAnalysisClipsData: payload => ({
    type: REQUEST_ANALYSIS_CLIPS_DATA,
    payload
  }),
  requestAnalysisClipsWithoutUrl: payload => ({
    type: REQUEST_ANALYSIS_CLIPS_WITHOUT_URL,
    payload
  }),
  analysisClipsDataReceived: () => ({
    type: ANALYSIS_CLIPS_DATA_RECEIVED
  }),
  analysisClipsWithoutUrlReceived: () => ({
    type: ANALYSIS_CLIPS_WITHOUT_URL_RECEIVED
  }),
  requestDeleteCustomtag: () => ({
    type: REQUEST_DELETE_CUSTOMTAG,
    paylaod
  }),
  deleteCustomtagReceived: () => ({
    type: DELETE_CUSTOMTAG_RECEIVED
  }),
  requestCustomTagUpdate: payload => ({
    type: REQUEST_CUSTOM_TAG_UPDATE,
    payload
  }),
  customTagUpdateReceived: () => ({
    type: CUSTOM_TAG_UPDATE_RECEIVED
  }),
  requestDeleteCohort: () => ({
    type: REQUEST_DELETE_COHORT,
    payload
  }),
  deleteCohortReceived: () => ({
    type: DELETE_COHORT_RECEIVED
  })
};
